import {parsePhoneNumberWithError} from 'libphonenumber-js';

export const formatPhoneNumber = (
  phone: string,
  showCountryCode: boolean = false,
) => {
  if (!phone) return '';

  const phoneNumber = parsePhoneNumberWithError(phone);
  if (!phoneNumber) return phone;

  const countryCode = phoneNumber.countryCallingCode;
  const nationalNumber = phoneNumber.formatNational();

  const formattedNational = nationalNumber.replace(/^(\d{3})/, '($1)');

  return showCountryCode
    ? `+${countryCode} ${formattedNational}`
    : formattedNational;
};
